import { Link } from 'react-router-dom';
import type { Channel } from '../data/mock';
import { formatCount } from '../lib/format';

/** A channel tile for the Explore grid — hero image, name, follower count. */
export function ChannelTile({ channel }: { channel: Channel }) {
  return (
    <Link
      to={`/c/${channel.slug}`}
      className="group relative block aspect-[4/3] overflow-hidden rounded-xl border border-provny-border dark:border-provny-border-dark"
    >
      <img
        src={channel.image}
        alt={channel.name}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 p-4 text-white">
        <h3 className="font-heading text-lg font-bold tracking-tight">{channel.name}</h3>
        <p className="mt-0.5 text-sm text-white/80">{channel.tagline}</p>
        <p className="mt-2 font-mono text-xs text-white/70">
          {formatCount(channel.followers)} followers
        </p>
      </div>
    </Link>
  );
}
